<template>
    <div id="fiche-bu-audit-block" class="background-quaternary-lighter">
        <div class="background-quaternary flex text-center">
            <div class="col-12">
                <as-title class="color-white" :title="$t('ficheBu.detail.audit_block.title')" :size="4"></as-title>
            </div>
        </div>
        <template v-if="!this.auditData || !this.auditData.length">
            <div class="mt-3 mb-3">
                <div v-if="isBusy" class="h-100 flex align-items-center">
                    <ProgressBar mode="indeterminate" style="height: 3px; max-width: 75%;" class="flex-1 m-auto">
                    </ProgressBar>
                </div>
                <template v-else>
                    <div class="flex flex-column h-100 align-items-center text-center">
                        <as-title class="mt-auto" :title="$t('ficheBu.detail.no_data_message')" :size="6"></as-title>
                        <img :src="noDataImage" class="ml-auto mr-auto mb-auto" />
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <div id="fiche-bu-audit-block__header"
                class="flex align-items-center text-center background-safety-card-border-blue color-white">
                <as-title :title="$t('ficheBu.detail.audit_block.year_tilte')" :size="5"
                    class="flex-1 color-white"></as-title>
                <div v-for="(item) in auditData" :key="item.year" class="flex-1 font-bold">{{ item.year }}</div>
            </div>
            <div id="fiche-bu-audit-block__content" class="flex align-items-center text-center">
                <as-title :title="$t('ficheBu.detail.audit_block.input_title')" :size="5"
                    class="flex-1 color-white"></as-title>
                <span v-for="(item) in auditData" :key="item.year" class="flex-1 font-bold">
                    {{ getAuditDataLabel(item.value) }}
                </span>
            </div>
        </template>
    </div>
</template>

<script>
import AsIcon from "../Elements/AsIcon.vue";
import AsTitle from "../Elements/AsTitle.vue";
import Chip from "primevue/chip";
import InputText from "primevue/inputtext";

export default {
    name: "FicheBuPerformanceBlock",
    components: {
        AsTitle,
        AsIcon,
        Chip,
        InputText
    },
    props: {
        auditData: {
            type: Array,
        },
        isBusy: Boolean
    },
    computed: {
    },
    data() {
        return {
            noDataImage: new URL("../../assets/images/icons/no-data-warning.png", import.meta.url).href,
        };
    },
    methods: {
        getAuditDataLabel(value) {
            return this.$t(`ficheBu.audit_data_list.value_enum.${value}`)
        },
    }
};
</script>
<style lang="scss">
@import "../../assets/styles/colors.scss";

#fiche-bu-audit-block {
    &__header {
        border-bottom: 2px solid white;
    }

    &__header,
    &__content {
        >* {
            line-height: 1.4rem !important;
        }
    }

    &__content {
        >:first-child {
            background: $quaternary_light_color !important;
        }
    }

    &__header,
    &__content {
        >*:not(:last-child) {
            border-right: 2px solid white;
            padding: 10px 0;
        }
    }
}
</style>
